import React from "react";
import { Link } from "react-router-dom";
import { LogoBox, logoRequestSrc } from "@/components/buyer/BuyerLogoRequest";
import { InboxActions } from "./InboxActions";
import { STATUS_STYLE, TYPE_LABEL, fmtWhen, statusLabel } from "./inboxMeta";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function Changes({ item, p }) {
  if (item.type === "logo") {
    return (
      <div className="mt-2 flex flex-wrap gap-4" data-testid={`${p}-logos`}>
        <LogoBox src={item.current_logo_url ? `${BACKEND}${item.current_logo_url}` : null} label={item.status === "pending" ? "Current" : "Before"} testId={`${p}-logo-current`} />
        {item.has_logo_file ? <LogoBox src={logoRequestSrc(item.id)} label="New" testId={`${p}-logo-new`} />
          : <div className="self-end text-[10px] text-zinc-500">The uploaded file is removed once decided.</div>}
      </div>
    );
  }
  if (item.type === "consent") {
    const c = item.changes[0];
    const pending = item.status === "pending";
    return (
      <div className="mt-2 grid gap-2 md:grid-cols-2" data-testid={`${p}-changes`}>
        {[[pending ? "Live now" : "Before", c.before, "border"], [pending ? "Wanted" : "Asked for", c.after, "border-2"]].map(([label, text, b]) => (
          <div key={label}><div className="label-mono mb-1">{label}</div>
            <div className={`${b} border-black bg-white p-2 text-[11px] leading-relaxed whitespace-pre-wrap`}>{text}</div></div>
        ))}
      </div>
    );
  }
  return (
    <ul className="mt-1.5 space-y-0.5 text-[11px]" data-testid={`${p}-changes`}>
      {item.changes.map((c) => (
        <li key={c.label} className="break-words"><b>{c.label}:</b>{" "}
          {c.before && <><span className="text-zinc-500 line-through">{c.before}</span> → </>}
          <span className="font-semibold">{c.after || "—"}</span></li>
      ))}
      {!item.changes.length && <li className="italic text-zinc-500">Nothing different from what they have now.</li>}
    </ul>
  );
}

function Decided({ item, p }) {
  if (item.status === "pending") return null;
  const who = item.reviewed_by?.name || item.reviewed_by?.email;
  return (
    <div className="mt-2 text-[11px] text-zinc-600" data-testid={`${p}-decided`}>
      {statusLabel(item.status)}{who ? ` by ${who}` : ""} · {fmtWhen(item.reviewed_at)}
      {item.review_note && <div>Note: {item.review_note}</div>}
    </div>
  );
}

export function InboxRow({ item, onDone }) {
  const p = `inbox-${item.source}-${item.id}`;
  return (
    <div className="border-b border-black p-4 last:border-b-0 transition-colors duration-100 hover:bg-zinc-50" data-testid={p}>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="bg-black px-1.5 py-0.5 text-[9px] uppercase tracking-widest text-white" data-testid={`${p}-type`}>{TYPE_LABEL[item.type]}</span>
        <b className="min-w-0 break-words" data-testid={`${p}-buyer`}>{item.buyer}</b>
        <span className="text-zinc-500">{item.submitted_by?.name || item.submitted_by?.email}</span>
        <span className="font-mono text-[10px] text-zinc-500">{fmtWhen(item.submitted_at)}</span>
        <span className={`border px-1.5 py-0.5 text-[9px] uppercase tracking-widest ${STATUS_STYLE[item.status] || ""}`} data-testid={`${p}-status`}>{statusLabel(item.status)}</span>
        {item.is_test && <span className="border border-zinc-500 px-1.5 py-0.5 text-[9px] uppercase tracking-widest text-zinc-600">Test buyer</span>}
        {item.org_id && <Link to={`/clients/${item.org_id}/manage`} className="ml-auto text-[10px] uppercase tracking-widest underline" data-testid={`${p}-open`}>Open buyer</Link>}
      </div>
      <Changes item={item} p={p} />
      {item.note && <div className="mt-2 border-l-4 border-amber-500 bg-amber-50 p-2 text-xs whitespace-pre-wrap" data-testid={`${p}-note`}>{item.note}</div>}
      {item.status === "pending" ? <InboxActions item={item} onDone={onDone} /> : <Decided item={item} p={p} />}
    </div>
  );
}
